import React, { memo } from "react";
import { classNames, useTranslate } from "helpers";
import { IntegrationGroupFilterProps } from "./types";

const IntegrationGroupFilter: React.FC<IntegrationGroupFilterProps> = ({
  groups,
  selectedGroup,
  onGroupSelect,
  integrationCounts,
}) => {
  const { t } = useTranslate();

  const totalCount = Object.values(integrationCounts).reduce((sum, count) => sum + count, 0);

  return (
    <div className="bg-white rounded-sm border border-slate-200 ">
      {/* Header */}
      <div className="flex items-center justify-between pb-3 border-b border-slate-200 p-4">
        <h3 className="text-sm font-semibold text-slate-800 uppercase tracking-wide">
          {t("admin.integration.filter.category")}
        </h3>
      </div>

      {/* All integrations option */}
      <div className="space-y-2 py-3 px-3">
        <button
          onClick={() => onGroupSelect(null)}
          className={classNames(
            "w-full flex items-center justify-between px-3 py-2 rounded-md text-left transition-colors duration-150",
            selectedGroup === null
              ? "bg-blue-50 text-blue-700 font-medium"
              : "text-slate-600 hover:bg-slate-50"
          )}
        >
          <span className="text-sm">{t("admin.integration.filter.all")}</span>
          <span
            className={classNames(
              "text-xs px-2 py-0.5 rounded-full",
              selectedGroup === null
                ? "bg-blue-100 text-blue-700"
                : "bg-slate-100 text-slate-600"
            )}
          >
            {totalCount}
          </span>
        </button>

       

        {/* Group filters */}
        {groups.map((group) => (
          <button
            key={group.id}
            onClick={() => onGroupSelect(group.id)}
            className={classNames(
              "w-full flex items-center justify-between px-3 py-2 rounded-md text-left transition-colors duration-150",
              selectedGroup === group.id
                ? "bg-blue-50 text-blue-700 font-medium"
                : "text-slate-600 hover:bg-slate-50"
            )}
          >
            <span className="text-sm">{t(group.name)}</span>
            <span
              className={classNames(
                "text-xs px-2 py-0.5 rounded-full",
                selectedGroup === group.id
                  ? "bg-blue-100 text-blue-700"
                  : "bg-slate-100 text-slate-600"
              )}
            >
              {integrationCounts[group.id] || 0}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default memo(IntegrationGroupFilter);
